import { Routes } from '@angular/router';
import { authGuard } from './services/guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { UserComponent } from './pages/user/user.component';
import { HomeComponent } from './pages/home/home.component';

import { SignersListComponent } from './pages/signers/signers-list.component';
import { SignerFormComponent } from './pages/signers/signer-form.component';
import { ComplaintComponent } from './pages/complaint/complaint.component';
import { ComplaintStatusComponent } from './pages/complaint/complaint-status.component';
import { ComplaintTypesComponent } from './pages/complaint/complaint-types.component';
import { ComplaintImportComponent } from './pages/complaint/complaint-import.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ComplaintImportActiveComponent } from './pages/complaint/complaint-import-active.component';
import { ComplaintDetailsComponent } from './pages/complaint/complaint-details.component';
import { ComplaintEditComponent } from './pages/complaint/complaint-edit.component';
import { ComplaintMapComponent } from './pages/complaint/complaint-map.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login', 
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
    children: [
     
     {
        path: 'signers',
        component: SignersListComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_MEDIUMUSER' }, // Role necessária para acessar
      },
      {
        path: 'signers-list',
        redirectTo: 'signers',
        pathMatch: 'full',
      },
      {
        path: 'signers/new',
        component: SignerFormComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_MEDIUMUSER' }, // Role necessária para acessar
      },
      {
        path: 'signers/edit/:id',
        component: SignerFormComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_MEDIUMUSER' }, // Role necessária para acessar
      },
      {
        path: 'users',
        component: UserComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_ADMIN' },
      },
      {
        path: 'complaints',
        component: ComplaintComponent,
        canActivate: [authGuard],
      },
      {
        path: 'complaints/details/:id',
        component: ComplaintDetailsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'complaints/new',
        component: ComplaintEditComponent,
        canActivate: [authGuard],
      },
      {
        path: 'complaints/edit/:id',
        component: ComplaintEditComponent,
        canActivate: [authGuard],
      },
      {
        path: 'complaints/map',
        component: ComplaintMapComponent,
        canActivate: [authGuard],
      },
      {
        path: 'complaint-status',
        component: ComplaintStatusComponent,
        canActivate: [authGuard],
      },
      {
        path: 'complaint-types',
        component: ComplaintTypesComponent,
        canActivate: [authGuard],
      },
      {
        path: 'complaint-import',
        component: ComplaintImportComponent,
        canActivate: [authGuard],
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_ADMIN' },
      },
      {
        path: 'complaint-import-active',
        component: ComplaintImportActiveComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_ADMIN' },
      }
      
    ],
  },

  {
    path: '**',
    redirectTo: '',
   // pathMatch: 'full',
  },
];

